import ApiService from "../ApiService";
import ApiServiceV2 from "../ApiServiceV2";
const user = JSON.parse(localStorage.getItem("user"));

export default class ProductService {
  static getModule = async (params) => {
    const instance = await ApiService();
    return instance.get("/module");
  };

  static getData = async (params) => {
    console.log(params);
    // let tenant_id =
    //   user.type === "tenant"
    //     ? `tenant_id=${user.tenant.id}`
    //     : params.tenant_id
    //     ? `tenant_id=${params.tenant_id}`
    //     : "";

    let category_id, page, perPage, deleted, keyword, property_id;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }

    if (params.page && params.page !== "") {
      page = `page=${params.page}`;
    }
    if (params.perPage && params.perPage !== "") {
      perPage = `&per_page=${params.perPage}`;
    }
    if (params.deleted && params.deleted !== "") {
      deleted = `&deleted=${params.deleted}`;
    } else {
      deleted = `&deleted=false`;
    }
    // console.log(params);
    // console.log(property_id);
    // console.log(params.property_id);
    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.property_id === 0) {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&email=${params.keyword}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiServiceV2();
      return instance.get(
        `/newsletter?${page || ""}${perPage || ""}${keyword || ""}`
      );
    } else {
      return {
        data: [],
      };
    }
  };

  static getResume = async (params) => {
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";
    let category_id, keyword, type, property_id;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `email=${params.keyword}`;
    }
    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }
    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiServiceV2();
      return instance.get(
        `/newsletter/resume?${tenant_id}${category_id || ""}${keyword || ""}${
          property_id || ""
        }`
      );
    } else {
      return {
        data: [],
      };
    }
  };
  static getResumeCurrated = async (params) => {
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";
    let category_id, keyword, type;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiService();
      return instance.get(
        `/product/curated/resume?${tenant_id}${category_id || ""}${
          keyword || ""
        }${type || ""}`
      );
    } else {
      return {
        data: [],
      };
    }
  };

  static getDataProduct = async (params) => {
    const instance = await ApiService();
    return instance.get(`/product/${params}`);
  };
  static getExportUser = async () => {
    const instance = await ApiServiceV2();
    return instance.get(`/newsletter/download`);
  };
}
